// 中英文切换配置
import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

let messages = {
  zh_cn: {},
  en: {},
};
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh_cn", // 设置地区
  messages, // 设置地区信息
  // silentTranslationWarn: true,
});
export default i18n;
